<template>
  <div id="app">

    <section class="bg-dark2">
      <div class="container-fluid pt-3">
        <header>
          <div class="row justify-content-center align-content-center">
            <div class="col-7 col-md-5 text-left">
              <img :src="settings.logos.header_title" height="60" >
            </div>
            <div class="col-5 col-md-7 text-right">
              <h1 class="main_title pr-3 d-md-inline-block" :class="$mq" v-html="$options.filters.translategrader(settings.copy.home_title,$i18n.locale)">Okedito Easy Grader<sup>®</sup></h1>
              <header-social-icons></header-social-icons>
            </div>
            <div class="w-100"></div>

          </div>
        </header>
      </div>
    </section>



  </div>
</template>

<script>

import { mapGetters } from 'vuex';
import HeaderSocialIcons from '@/components/HeaderSocialIcons';

export default {
    name: 'Header',

    components: {
      HeaderSocialIcons,
    },

    props: {
      settings: {
        type: Object,
        required: true
      }
    }
}

</script>

<style scoped>
.bg-dark2{
  background: var(--colorPrimary);
}

header p {
  color: #fff;
}

.main_title{
  color: #fff!important;
  font-size: 16px;
  padding-top: 27px;
  display: inline-block;

}
.intro .main_title {
  padding-top: 36px;
}

.social_share_link img{
  margin-top: -8px;
}


</style>



// WEBPACK FOOTER //
// src/components/Header.vue